import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const calendly = defineConnector({
  identifier: "calendly",
  name: "Calendly",
  tagLine: "Scheduling automation platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.calendly\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Calendly API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Calendly Integrations](https://calendly.com/integrations/api_webhooks) page and generate a **Personal Access Token**.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Personal Access Token",
          placeholder: "eyJraWQiOiIx...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.calendly.com/users/me",
  },
});
